import { View } from 'backbone';
import util from 'util/Util.js'
import Template from 'behaviors/properties/main/report-misc.ejs';


class MainReportMiscView extends View {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            'change input[type="checkbox"]':'updateCheckboxes'
        };

        return this;
    }

    updateCheckboxes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        this.model.set( propName, propVal );
    }

    render() {

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let bShowError = util.isTrue(this.model.get('showError'));
        $(`input[name='showError']`).prop('checked', bShowError );

        let bNewWindow = util.isTrue(this.model.get('newWindow'));
        $(`input[name='newWindow']`).prop('checked', bNewWindow );

        this.delegateEvents();
        return this;
    }

}

export default MainReportMiscView;
